import { Typography } from '@mui/material';
import Modal from 'components/v2/modal/Modal';
import { MODAL_ID, MODALS_STORE } from 'constants/ui/modal';
import { useLocalization } from 'localization';

type Props = {
  onConfirm: () => void;
};

const WarnPropertySizeModal = (props: Props) => {
  const { onConfirm } = props;
  const { t } = useLocalization();
  const { toggleModal, isModalOpen } = MODALS_STORE.createOrder();

  const handleConfirm = () => {
    onConfirm();
    toggleModal(MODAL_ID.CREATE_ORDER_WARN_PROPERTY_SIZE);
  };

  return (
    <Modal
      modalTitle={t('modals.propertySizeAlert.title')}
      isOpen={isModalOpen(MODAL_ID.CREATE_ORDER_WARN_PROPERTY_SIZE)}
      toggleModal={() => toggleModal(MODAL_ID.CREATE_ORDER_WARN_PROPERTY_SIZE)}
      onConfirm={handleConfirm}
      confirmBtnLabel={t('common.terms.yes')}
      cancelBtnLabel={t('common.terms.no')}
    >
      <Typography sx={{ my: '2rem' }}>{t('modals.propertySizeAlert.message')}</Typography>
    </Modal>
  );
};

export default WarnPropertySizeModal;
